import React, {CSSProperties, useMemo} from 'react'
import styled from 'styled-components'
import convertUnit from 'lib/unit'
import {Icon, Paragraph} from 'common/components'
import {
  GIFT_SHOP_TRANSACTION_STATUS_COLORS,
  GIFT_SHOP_TRANSACTION_STATUS_ICONS,
  WINDOW_MODE_MOBILE_WIDTH,
  WINDOW_MODE_TABLET_WIDTH,
} from 'consts'
import {useTranslation} from 'i18n'
import {TransactionDetailContentHeaderProps} from './TransactionDetailContentHeaderProps'

const StyledFlexContainer = styled.div<CSSProperties>`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(4)};
  margin-bottom: ${convertUnit(20)};
  margin-right: 0;
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    margin-right: ${convertUnit(25)};
  }
  @media (max-width: ${WINDOW_MODE_MOBILE_WIDTH}px) {
    margin-right: 0;
  }
`

export default function TransactionDetailContentHeader({
  statuses,
  subTitle,
  title,
  titleRightElement,
  subtitleRightElement,
  padding,
}: TransactionDetailContentHeaderProps) {
  const {translate} = useTranslation()

  const handleRenderStatuses = useMemo(
    () =>
      statuses ? (
        <StyledFlexContainer>
          {statuses.map(
            ({status, count, hideIcon, overrideStatusText}, idx) => {
              const phrase =
                overrideStatusText ??
                translate('giftShop:transactionStatus', {
                  context: status,
                })
              return (
                <div
                  style={{display: 'flex', alignItems: 'center'}}
                  key={status}>
                  {idx > 0 ? (
                    <Paragraph
                      style={{
                        marginLeft: convertUnit(2),
                      }}
                      color="gray_3">
                      •
                    </Paragraph>
                  ) : (
                    <></>
                  )}
                  {!hideIcon && (
                    <Icon
                      type={GIFT_SHOP_TRANSACTION_STATUS_ICONS[status]}
                      color={GIFT_SHOP_TRANSACTION_STATUS_COLORS[status]}
                    />
                  )}
                  <Paragraph
                    fontWeight="bold"
                    color={GIFT_SHOP_TRANSACTION_STATUS_COLORS[status]}
                    fontSize="m">
                    {statuses.length > 1 ? `${count} ${phrase}` : phrase}
                  </Paragraph>
                </div>
              )
            },
          )}
        </StyledFlexContainer>
      ) : (
        <></>
      ),
    [statuses, translate],
  )

  return (
    <StyledHeaderContainer
      style={{
        padding,
      }}>
      {handleRenderStatuses}
      <StyledFlexContainer
        style={{
          width: '100%',
          justifyContent: 'space-between',
        }}>
        <Paragraph fontWeight="bold" fontSize="xl">
          {title}
        </Paragraph>
        {titleRightElement}
      </StyledFlexContainer>
      <StyledFlexContainer
        style={{
          width: '100%',
          justifyContent: 'space-between',
        }}>
        <Paragraph fontWeight="bold" color="gray_5" fontSize="m">
          {subTitle}
        </Paragraph>
        {subtitleRightElement}
      </StyledFlexContainer>
    </StyledHeaderContainer>
  )
}
